import { useContext } from "react";
import { LoginContext } from "./Login";
import UserForm from "./Forms/UserForm";
import SecuritySettings from "./Forms/SecuritySettings";
import { T } from "./traks";

const MainPage = () => {
	const { signOut, user } = useContext(LoginContext);
	return (
		<div className="page-wrapper">
			<h2 className="page-title">
				<T>Welcome, {user?.agentId}</T>
			</h2>
			{!!user?.affiliates?.length && (
				<div className="app-card">
					<div className="app-card-header">
						<T>Affiliates</T>
					</div>
					<div className="app-card-body">
						<div className="d-flex flex-wrap gap-2">
							{user.affiliates.map((aff) => (
								<span key={aff} className="affiliate-badge">
									{aff}
								</span>
							))}
						</div>
					</div>
				</div>
			)}
			{user?.details && <UserForm />}
			<SecuritySettings />
			<div className="mt-3">
				<button className="btn btn-outline-danger" onClick={signOut}>
					<T>Log out</T>
				</button>
			</div>
		</div>
	);
};

export default MainPage;
